export const ANSWER_SET_ROUTE_NAME = 'suppliers-profile-answer-set';
